import { getAllEmployees, getEachEmployees } from '../services/userService';
import { useState } from 'react';
import { ObjectType } from '../constant/serviceType';

export const useEmployee = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [allEmployee, setAllEmployee] = useState([]);
  const [eachEmployee, setEachEmployee] = useState<ObjectType>({});
  const [eachEmployeeTransaction, setEachEmployeeTransaction] = useState([]);

  const getAllEmployee = async (id: string | number) => {
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getAllEmployees(id);
      console.log('ALL EMPLOYEE PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setAllEmployee(response?.data?.data.users);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e.response.data.message);
      setLoading(false);
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };

  const getIndividualEmployee = async (id: string | number) => {
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getEachEmployees(id);
      console.log('ALL EMPLOYEE PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setEachEmployee(response?.data?.data);
        setEachEmployeeTransaction(response?.data?.data.transaction);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e.response.data.message);
      setLoading(false);
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };


  return {
    loading,
    getAllEmployee,
    allEmployee,
    getIndividualEmployee,
    eachEmployee,
    eachEmployeeTransaction,
  };
};
